module.exports = __webpack_public_path__ + "2c0bc9443b5832f3d056a322e5f63d2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/4.svg
// module id = 699
// module chunks = 0